export default function Hero() {
  const handleScrollTo = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      const headerHeight = 64;
      const top = target.getBoundingClientRect().top + window.scrollY - headerHeight;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden bg-background-100"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>

      <div className="relative w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-5">
              <i className="ri-fire-line text-sm w-4 h-4 flex items-center justify-center"></i>
              <span className="whitespace-nowrap">今日爆料 · 实时更新</span>
            </div>

            <h1 className="font-heading font-black text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-4">
              51吃瓜最新网址
              <span className="block text-primary-500">吃瓜爆料第一站</span>
            </h1>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4 max-w-xl mx-auto lg:mx-0">
              汇聚全网最新最全的吃瓜爆料、黑料实锤与热门话题，51吃瓜最新网址每日更新娱乐圈、网红圈的独家内幕与精彩视频合集。
              无论是今日黑料视频还是历史爆料汇总，吃瓜群众的第一手资讯平台，随时随地不错过任何一条重磅消息。
            </p>

            <p className="text-sm text-foreground-500 leading-relaxed mb-6 max-w-xl mx-auto lg:mx-0">
              本站持续追踪热门事件，坚持第一时间汇总多方信息，为吃瓜群众提供最快、最全、最真实的爆料内容。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-7">
              <div className="text-center">
                <div className="font-heading font-bold text-xl md:text-2xl text-primary-500">2000+</div>
                <div className="text-xs text-foreground-500 mt-0.5 whitespace-nowrap">累计爆料</div>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="font-heading font-bold text-xl md:text-2xl text-accent-500">每日更新</div>
                <div className="text-xs text-foreground-500 mt-0.5 whitespace-nowrap">内容覆盖</div>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="font-heading font-bold text-xl md:text-2xl text-primary-500">全网最快</div>
                <div className="text-xs text-foreground-500 mt-0.5 whitespace-nowrap">爆料速度</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                onClick={(e) => handleScrollTo(e, '#cards')}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-flashlight-line text-base w-4 h-4 flex items-center justify-center"></i>
                查看热门爆料
              </a>
              <a
                href="#carousel"
                onClick={(e) => handleScrollTo(e, '#carousel')}
                className="inline-flex items-center gap-2 px-6 py-3 border border-background-300 text-foreground-700 font-medium text-sm rounded-lg hover:bg-background-100 hover:border-background-400 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-article-line text-base w-4 h-4 flex items-center justify-center"></i>
                浏览焦点专题
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[500px] lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden bg-background-200/50">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20composition%20with%20warm%20crimson%20and%20deep%20gold%20tones%2C%20dynamic%20flowing%20shapes%20suggesting%20breaking%20news%20and%20digital%20media%20energy%2C%20modern%20editorial%20aesthetic%20with%20layered%20translucent%20geometric%20elements%2C%20sophisticated%20dark%20warm%20gradient%20background%2C%20visual%20metaphor%20for%20information%20flow%20and%20entertainment%20industry%2C%20no%20text%2C%20high%20contrast%2C%20cinematic%20atmospheric%20lighting%2C%20smooth%20fluid%20motion%20blur%20effects&width=1600&height=900&seq=hero-main-visual&orientation=landscape"
                alt="51吃瓜最新网址 - 吃瓜爆料第一站主视觉"
                className="w-full h-auto object-cover"
                title="51吃瓜最新网址主视觉"
                loading="eager"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/30 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}